"use client";

import Image from "next/image";

import { Post } from "@/app/utils/interface";

// Function to get YouTube thumbnail URL
const getYouTubeThumbnail = (videoId: string) => {
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
};

interface VideoThumbnailProps {
  post: Post;
}

export default function VideoThumbnail({ post }: VideoThumbnailProps) {
  return (
    <div className="aspect-w-16 aspect-h-9 overflow-hidden">
      <Image
        src={
          post.cloudinaryImage?.secure_url ||
          getYouTubeThumbnail(post.youtubeVideo || "")
        }
        alt={post.title}
        width={500}
        height={300}
        className="size-full object-cover transition-transform duration-300 group-hover:scale-105"
        onError={(e) => {
          // Fallback to a lower quality thumbnail if maxresdefault fails
          if (post.youtubeVideo) {
            const target = e.target as HTMLImageElement;
            target.src = `https://img.youtube.com/vi/${post.youtubeVideo}/hqdefault.jpg`;
          }
        }}
      />
    </div>
  );
}
